import { z } from 'zod';
/**
 * A contact attached to an encounter, as primary serves it. A contact hangs off either an encounter
 * or an EHR information record, so the other identifier is always null.
 */
export const EncounterContactSchema = z.object({
    id: z.uuid(),
    created: z.iso.datetime(),
    updated: z.iso.datetime(),
    encounterId: z.uuid(),
    ehrInformationId: z.uuid().nullable(),
    name: z.string(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    contactByEmail: z.boolean(),
    contactByText: z.boolean(),
    deleted: z.boolean(),
});
/** Query params for `GET /flow/data-access/encounter-contacts`. */
export const EncounterContactFindAllQuerySchema = z
    .object({
    encounterId: z.uuid(),
})
    .strict();
//# sourceMappingURL=encounterContact.js.map